import "./product-description.scss";

const ProductDescription = () => (

    <section className = "product-description-block">
        <h4 className = "product-description-title">
            DESCRIPTION
        </h4>
    </section>
);

export default ProductDescription;